// these values are meant to be bitwise or'ed together, so must be powers of 2
export const EXTRA_SUBSCRIBE_TO_PRICE_DROPS = Math.pow(2, 0)
export const EXTRA_SEND_TO_PHONE = Math.pow(2, 1)
